import createErrorHandler from 'utils/createErrorHandler';

function validateContest(state) {
  const [errors, addError] = createErrorHandler();

  if (!state.contest) {
    addError('contest', 'Select a contest and duration to proceed!');
    return errors;
  }

  if (!state.contest.duration) {
    addError('contest', 'Select a duration to proceed!');
  }

  if (state.contestType === 'group' && !state.contest.test_group_id) {
    addError('contest', 'Select a Group Contest Id to proceed!');
  }

  if (state.contestType === 'group' && !state.contest.course_type) {
    addError('contest', 'Select a Course Type to proceed!');
  }

  return errors;
}

export default validateContest;
